import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import HumanAvatar from '@sprinx/react-mui-components/HumanAvatar';
import AuthUser from '@sprinx/react-auth/AuthUser';

var Wrap = function Wrap(_ref) {
  var children = _ref.children,
      userNullable = _ref.userNullable;
  return (// eslint-disable-line react/prop-types
    userNullable ? children({
      user: userNullable
    }) : React.createElement(AuthUser, {
      render: function render(_ref2) {
        var user = _ref2.user;
        return children({
          user: user
        });
      }
    })
  );
};

var propTypes = {
  onClick: PropTypes.func,

  /**
   * Objekt uzivatele. Pokud neni poskytnut jsou pouzity informace o aktualne prihlasenem uzivateli.
   */
  user: PropTypes.shape({})
};
var defaultProps = {
  onClick: undefined,
  user: undefined
};
/**
 * Avatar zobrazujici in
 *
 * Je mozne pouzit vsechny property z komponentu `AvatarPreview`.
 */

export default function UserAvatar(props) {
  var onClick = props.onClick,
      userNullable = props.user,
      rest = _objectWithoutProperties(props, ["onClick", "user"]);

  return React.createElement(Wrap, {
    userNullable: userNullable
  }, function (_ref3) {
    var user = _ref3.user;
    return React.createElement(HumanAvatar, _extends({}, rest, {
      human: user,
      onClick: onClick
    }));
  });
}
UserAvatar.propTypes = propTypes;
UserAvatar.defaultProps = defaultProps;